import React from "react";

import { Stack, TextField, Typography } from "@mui/material";

import { floatingTextFieldSx, sectionSubtitleSx, sectionTitleSx } from "./styles";

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const GuidancePanel: React.FC<Props> = ({ value, onChange }) => {
  const isEmpty = !value.trim();
  return (
    <Stack gap="20px" sx={{ pt: "20px" }}>
      <Stack>
        <Typography sx={sectionTitleSx}>Feed Guidance</Typography>
        <Typography sx={sectionSubtitleSx}>
          Use this to steer how the AI ranks and filters news. It does not act like a direct search query.
        </Typography>
      </Stack>
      <TextField
        fullWidth
        required
        multiline
        minRows={4}
        value={value}
        error={isEmpty}
        helperText={isEmpty ? "Guidance is required" : undefined}
        onChange={(e) => onChange(e.target.value)}
        sx={floatingTextFieldSx}
      />
    </Stack>
  );
};
